// import COMMON_ENDPOINTS from './commons';
import PROD_ENDPOINTS from './prod';
import DEV_ENDPOINTS from './dev';
import STAGE_ENDPOINTS from './stagging';

/**
 * @todo: {process.env.NODE_ENV} undefined in case of Production
 */
const getEndPoints = () => {
  const key = process.env.NODE_ENV;
  switch (key) {
    case 'development':
      return DEV_ENDPOINTS;
    case 'staging':
      return STAGE_ENDPOINTS;
    default:
      return PROD_ENDPOINTS;
  }
};

const endPoints = getEndPoints();
export default endPoints;



// WEBPACK FOOTER //
// client/config/endPoints/index.js